// @flow

import settings from './reducers';
import getComponentSettings from './selectors';

export {
  getComponentSettings,
};
export {
  getCarBlockButtonText,
  getCarBlockContractDurationAbbrv,
  getCarBlockDeliveryTime,
  getCarBlockDeliveryTimeApproximately,
  getCarBlockDeliveryTimeDurationPlural,
  getCarBlockDeliveryTimeDurationSingle,
  getCarBlockMileageAbbrv,
  getCarBlockPriceDuration,
  getCarBlockPriceLabel,
  getCarBlockRoadtaxNote,
  getCarBlockContractPrefixText,
  getListCollapsibleButton,
  getListVisibleItemCount,
  getPdbCTAAddToComparisonText,
  getPdbCTAButtonText,
  getPdbCTADeliveryTime,
  getPdbCTADeliveryTimeApproximately,
  getPdbCTADeliveryTimeDurationPlural,
  getPdbCTADeliveryTimeDurationSingle,
  getPdbCTAMaxItemsInComparison,
  getPdbCTARemoveFromComparisonText,
  getPdbCTAFormData,
  getPdbGalleryDisclaimerText,
  getPdbGalleryTheaterButtonText,
  getPdbInfoAvailableLabel,
  getPdbInfoBasePriceLabel,
  getPdbInfoContractDurationAbbrv,
  getPdbInfoMileageAbbrv,
  getPdbInfoOccasionLinkTextPlural,
  getPdbInfoOccasionLinkTextSingle,
  getPdbInfoRoadtaxNote,
  getPdbSpecificationDoors,
  getPdbSpecificationFuelInfo,
  getPdbSpecificationKeys,
  getPdbSpecificationTitle,
  getReviewAllReviewsLinkText,
  getReviewBasedOn,
  getReviewRating,
  getReviewReviewCount,
  getReviewReviews,
  getReviewScore,
  getWysiwygCollapsibleButton,
} from './selectors';
export {
  receivedComponentSettings,
} from './actions';
export type { State } from './reducers';
export type {
  CarBlockSettings,
  ListSettings,
  CTASettings,
  GallerySettings,
  InfoSettings,
  SpecificationSettings,
  ReviewSettings,
  WysiwygSettings,
} from './selectors';

export default settings;
